import { Menu as BaseMenu } from '@base-ui/react/menu';
import { Check } from 'lucide-react';
import Icon from '../primitives/Icon.jsx';

/**
 * A menu that opens from a trigger (account menu, row actions). `trigger` is the element that opens
 * it and receives the menu's props; items, radio groups and separators go in as children.
 */
const Menu = ({ trigger, align = 'start', side = 'bottom', children }) => {
  return (
    <BaseMenu.Root>
      <BaseMenu.Trigger render={trigger} />
      <BaseMenu.Portal>
        <BaseMenu.Positioner className="comp-menu__positioner" align={align} side={side} sideOffset={6}>
          <BaseMenu.Popup className="comp-menu">{children}</BaseMenu.Popup>
        </BaseMenu.Positioner>
      </BaseMenu.Portal>
    </BaseMenu.Root>
  );
};

/** One action in a menu. */
const MenuItem = ({ icon, onClick, children }) => {
  return (
    <BaseMenu.Item className="comp-menu__item" onClick={onClick}>
      {icon && <Icon icon={icon} />}
      <span className="comp-menu__label">{children}</span>
    </BaseMenu.Item>
  );
};

/** A set of choices where one is current, such as the theme. */
const MenuRadioGroup = ({ label, value, onValueChange, options, closeOnClick = false }) => {
  return (
    <BaseMenu.Group>
      {label && <BaseMenu.GroupLabel className="comp-menu__group-label">{label}</BaseMenu.GroupLabel>}
      <BaseMenu.RadioGroup value={value} onValueChange={onValueChange}>
        {options.map((option) => (
          <BaseMenu.RadioItem key={option.value} value={option.value} className="comp-menu__item" closeOnClick={closeOnClick}>
            {option.icon && <Icon icon={option.icon} />}
            <span className="comp-menu__label">{option.label}</span>
            <BaseMenu.RadioItemIndicator className="comp-menu__check">
              <Icon icon={Check} />
            </BaseMenu.RadioItemIndicator>
          </BaseMenu.RadioItem>
        ))}
      </BaseMenu.RadioGroup>
    </BaseMenu.Group>
  );
};

/** A line between groups of items. */
const MenuSeparator = () => <BaseMenu.Separator className="comp-menu__separator" />;

/** Text at the top of a menu that is not an action, such as who is signed in. */
const MenuHeader = ({ children }) => <div className="comp-menu__header">{children}</div>;

Menu.Item = MenuItem;
Menu.RadioGroup = MenuRadioGroup;
Menu.Separator = MenuSeparator;
Menu.Header = MenuHeader;

export default Menu;
